module.exports = __webpack_public_path__ + "80343ed6ac637183d30cdf775eacfccd.woff2";